const FilterPropertyRenderType = {
	DEFAULT: "default", // Renders as String.
	FLAG: "flag" // Renders a Flag graphic.
};
export default FilterPropertyRenderType;
